import { GenerationMethod, type VoiceStyle } from '@heidi/schema/ml-scribe';

import { getNoteGenerationEngineConfig } from '../../config';

export type CompletedGenerationAnalyticsInput = {
  isRegenerate?: boolean;
  voiceStyle?: VoiceStyle | null;
  oldVoiceStyle?: VoiceStyle;
  generationMethod?: GenerationMethod;
  templateId?: string | null;
  aiCommandText?: string | null;
  aiCommandId?: string | null;
};

/** Same completion branch and emit hosts; the caller passes its original input. */
export function trackNoteGenerationCompletedAnalytics(
  sessionId: string,
  input: CompletedGenerationAnalyticsInput
): void {
  const {
    noteSelectionRegenerateOutput,
    sessionVoiceUpdated,
    noteGeneratedByTemplate,
    sessionTemplateUpdated,
    noteGeneratedByAskAI,
    noteGeneratedByPressAICommand,
  } = getNoteGenerationEngineConfig().analytics;
  if (input.isRegenerate) {
    noteSelectionRegenerateOutput();
  } else if (input.voiceStyle) {
    sessionVoiceUpdated({
      voiceStyle: input.voiceStyle,
      oldVoiceStyle: input.oldVoiceStyle,
      sessionId,
    });
  } else {
    switch (input.generationMethod) {
      case GenerationMethod.TEMPLATE:
        noteGeneratedByTemplate(input.templateId || '');
        sessionTemplateUpdated({
          templateId: input.templateId || '',
          sessionId,
        });
        break;
      case GenerationMethod.AI_COMMAND_TEXT:
        noteGeneratedByAskAI();
        break;
      case GenerationMethod.PRESET_AI_COMMAND:
        noteGeneratedByPressAICommand(input.aiCommandId || '');
        break;
    }
  }
}
